export default "__VITE_PUBLIC_ASSET__0522767b__"